export const LoansHeroFormSectionTexts = {
  headingText: 'Подобрали кредиты',
  subHeadingText: 'Сравните условия в разных банках и решите, где лучше взять кредит',
};
